import React from "react";
import { CheckCircle2 } from "lucide-react";
import { COACH_IMAGE, GIFT_IMAGE, bonusItems } from "../mock";
import useReveal from "../hooks/useReveal";

export default function About() {
  const [ref, inView] = useReveal();

  return (
    <section id="about" className="bg-[#EAE9F6] pb-16">
      <div
        ref={ref}
        className={`reveal ${inView ? "in-view" : ""} mx-auto grid max-w-7xl grid-cols-1 gap-7 px-5 md:px-8 lg:grid-cols-2`}
      >
        {/* About card */}
        <div className="rounded-2xl bg-[#E3DDF7] p-8 md:p-9">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-start">
            <img
              src={COACH_IMAGE}
              alt="Rachelle Koulibaly"
              className="h-56 w-44 shrink-0 self-center rounded-2xl object-cover object-top shadow-md sm:self-start"
            />
            <div>
              <h2 className="font-serif-display text-[1.9rem] font-bold text-[#6618D0]">
                Hi, I'm Rachelle Koulibaly
              </h2>
              <p className="mt-3 text-[14px] leading-relaxed text-[#4a4a4a]">
                I'm a parent coach, speaker, and mom. I help working parents stay
                calm, set healthy boundaries, and raise confident, emotionally
                resilient kids, without pressure, guilt, or burnout.
              </p>
              <p className="mt-3 text-[14px] leading-relaxed text-[#4a4a4a]">
                This book is everything I've learned (and lived) as a mom, coach,
                and human.
              </p>
              <p className="mt-4 font-script text-2xl text-[#6618D0]">
                — Rachelle Koulibaly
              </p>
            </div>
          </div>
        </div>

        {/* Bonus card */}
        <div className="relative overflow-hidden rounded-2xl bg-[#E3DDF7] p-8 md:p-9">
          <h2 className="font-serif-display text-[1.7rem] font-bold text-[#990EE5]">
            Presale Bonus (For a Limited Time)
          </h2>
          <p className="mt-3 max-w-xs text-[14px] leading-relaxed text-[#4a4a4a]">
            Everyone who preorders will receive these exclusive bonuses:
          </p>

          <ul className="mt-5 space-y-3">
            {bonusItems.map((b) => (
              <li key={b} className="flex max-w-sm items-start gap-2.5">
                <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-[#6618D0]" />
                <span className="text-[13px] font-semibold text-[#2a2a2a]">{b}</span>
              </li>
            ))}
          </ul>

          {/* Gift image + badge */}
          <img
            src={GIFT_IMAGE}
            alt="Exclusive bonus gift"
            className="pointer-events-none absolute bottom-6 right-4 hidden h-32 w-32 rounded-xl object-cover md:block"
          />
          <div className="absolute right-6 top-8 hidden h-20 w-20 flex-col items-center justify-center rounded-full bg-[#6618D0] text-center leading-tight md:flex">
            <span className="text-[9px] font-extrabold text-white">EXCLUSIVE</span>
            <span className="text-[9px] font-extrabold text-white">BONUS</span>
            <span className="text-[9px] font-extrabold text-white">FOR YOU!</span>
          </div>
        </div>
      </div>
    </section>
  );
}
